/**
 * Fuul Typography Tokens
 *
 * Typography system using ClashGrotesk for display/titles and Inter for body text.
 * These values are defined in tailwind.config.ts.
 */

export const fontFamilies = {
  display: 'ClashGrotesk, sans-serif',
  body: 'Inter, sans-serif',
  mono: 'Roboto Mono, monospace',
} as const;

export const fontSizes = {
  // Display sizes (ClashGrotesk)
  'display-lg': {
    fontSize: '60px',
    lineHeight: '1.1',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'display-md': {
    fontSize: '46px',
    lineHeight: '1.1',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'display-sm': {
    fontSize: '36px',
    lineHeight: '1.2',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },

  // Title sizes (ClashGrotesk)
  'title-xl': {
    fontSize: '32px',
    lineHeight: '1.2',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'title-lg': {
    fontSize: '28px',
    lineHeight: '1.2',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'title-md': {
    fontSize: '24px',
    lineHeight: '1.3',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'title-sm': {
    fontSize: '20px',
    lineHeight: '1.3',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },
  'title-xs': {
    fontSize: '16px',
    lineHeight: '1.4',
    fontWeight: '500',
    fontFamily: 'ClashGrotesk',
  },

  // Body sizes (Inter) - Regular
  'body-lg': {
    fontSize: '16px',
    lineHeight: '1.5',
    fontWeight: '400',
    fontFamily: 'Inter',
  },
  'body-md': {
    fontSize: '14px',
    lineHeight: '1.5',
    fontWeight: '400',
    fontFamily: 'Inter',
  },
  'body-sm': {
    fontSize: '12px',
    lineHeight: '1.5',
    fontWeight: '400',
    fontFamily: 'Inter',
  },

  // Body sizes (Inter) - Bold
  'body-lg-bold': {
    fontSize: '16px',
    lineHeight: '1.5',
    fontWeight: '700',
    fontFamily: 'Inter',
  },
  'body-md-bold': {
    fontSize: '14px',
    lineHeight: '1.5',
    fontWeight: '700',
    fontFamily: 'Inter',
  },
  'body-sm-bold': {
    fontSize: '12px',
    lineHeight: '1.5',
    fontWeight: '700',
    fontFamily: 'Inter',
  },
} as const;

export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;
